<template>
  <div>
    <div class="row mt-3 mb-3 ml-1 mr-1">
      <div class="col-3">
        <label class="label">
          Número do livro
        </label>
        <interrogation text="Defina o número do livro que está sendo utilizado em seu cartório para essa impressão." />
        <input v-model="search.numero_livro"
               type="number"
               class="form-control form-control-sm">
      </div>
      <div class="col-3">
        <label class="label">
          Número da folha inicial
        </label>
        <interrogation text="Defina o número da folha inicial para essa impressão." />
        <input v-model="search.numero_folha_inicial"
               type="number"
               class="form-control form-control-sm">
      </div>
      <div class="col-3">
        <label class="label">
          Lado inicial
        </label>
        <select v-model="search.lado_inicial"
                class="custom-select custom-select-sm"
                name="lado_inicial"
                :disabled="!search.frente_verso">
          <option v-for="lado in lados_iniciais"
                  :key="lado"
                  :value="lado">
            {{ lado }}
          </option>
        </select>
      </div>
      <div class="col-3 d-flex align-items-end">
        <span class="custom-control custom-switch mb-1">
          <input id="`frente_verso`"
                 v-model="search.frente_verso"
                 class="custom-control-input"
                 name="frente_verso"
                 type="checkbox"
                 :value="1">
          <label class="custom-control-label"
                 for="`frente_verso`">Usar frente e verso</label>
        </span>
      </div>
    </div>
    <hr class="hr-secondary">
    <div class="row mt-3 mb-3 ml-1 mr-1 justify-content-end">
      <div class="col-3 d-flex">
        <button id="btn-cancel"
                class="btn btn-block btn-sm mt-0 mr-3"
                @click="backToProtocolos()">
          Cancelar
        </button>
        <button id="btn-print"
                class="btn btn-block btn-sm mt-0"
                @click="imprimir()">
          Imprimir
        </button>
      </div>
    </div>
    <div class="row">
      <div class="col">
        <div style="height: 100%">
          <object v-if="pdf != null"
                  class="document-preview embed-responsive"
                  :data="`${ pdf }`"
                  type="application/pdf">
            <p>Seu browser não suporta arquivos pdf diretamente ou este arquivo não existe. Você pode tentar efetuar o download clicando.</p>
          </object>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  /* services */
  import ProtocolosService from "@/services/Relatorios/ProtocolosService"

  /* components */
  import Interrogation from "@/components/SofiaRei/Interrogation"

  export default {
    name: "ProtocolosImprimir",
    components: {
      Interrogation
    },
    props: {
      previousSearch: null,
      pushed: null
    },
    data () {
      return {
        pdf: null,
        search: {
          numero_livro: null,
          numero_folha_inicial: null,
          frente_verso: false,
          lado_inicial: 'Frente'
        },
        lados_iniciais: ['Frente', 'Verso']
      }
    },
    created () {
      if (!this.pushed) this.backToProtocolos()
    },
    methods: {
      async imprimir () {
        this.$validator.validate().then(async status => {
          if (status) {
            try {
              loader({ active: true })
              this.pdf = await ProtocolosService.getPdf({ ...this.previousSearch, ...this.search })
            } finally {
              loader({ active: false })
            }
          }
        })
      },
      backToProtocolos () {
        this.$router.push({
          name: 'protocolos'
        })
      }
    }
  }
</script>

<style scoped>
  #btn-cancel {
    background-color: #C6C6C6;
    color: black;
  }

  #btn-print {
    background-color: #134F7F;
    color: white;
  }

  #btn-print:hover, #btn-cancel:hover {
    opacity: 90%;
  }

  .document-preview {
    height: 500px !important;
  }
</style>
